var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletAsh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66699 6H4.66699",
    stroke: "#AAAAAA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 9.86613C14.0058 9.86613 14.0117 9.86602 14.0177 9.86581C14.653 9.84312 15.1665 9.32901 15.1665 8.68616V7.31278C15.1665 6.66994 14.653 6.15582 14.0177 6.13313C14.0117 6.13292 14.0058 6.13281 13.9998 6.13281H12.6131C12.108 6.13281 11.6404 6.33157 11.2993 6.67945C10.9201 7.05217 10.7013 7.58915 10.7551 8.16394C10.8414 9.17899 11.7534 9.86613 12.6931 9.86613H13.9998Z",
    fill: "#AAAAAA",
    stroke: "#AAAAAA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.653 7.03398C11.373 7.30731 11.213 7.70065 11.253 8.12065C11.313 8.84065 11.973 9.36731 12.693 9.36731H13.9997V10.334C13.9997 12.334 12.6663 13.6673 10.6663 13.6673H4.66634C2.66634 13.6673 1.33301 12.334 1.33301 10.334V5.66732C1.33301 3.85398 2.42634 2.58732 4.12634 2.37398C4.29968 2.34732 4.47967 2.33398 4.66634 2.33398H10.6663C10.8397 2.33398 11.0063 2.34064 11.1663 2.36731C12.8863 2.56731 13.9997 3.84065 13.9997 5.66732V6.63399H12.613C12.2397 6.63399 11.8997 6.78064 11.653 7.03398Z",
    stroke: "#AAAAAA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletAsh);
export default __webpack_public_path__ + "static/media/wallet-ash.7bff2d4bfcc1c46f86f8544d372fec07.svg";
export { ForwardRef as ReactComponent };